import {getDocumentName} from '../../../utils/document';
import {pathHelpContentFile} from '../../../utils/path';
import {CONTENT_TYPE_INTERNAL_LINK, CONTENT_TYPE_TEXT, CONTENT_CATEGORY_MODEL} from '../../constants';

const DOCUMENT_PATH = `${pathHelpContentFile}fr/FR_MOD_QUAL/${getDocumentName("capacité d'entreprises ok")}.docx`;

export default {
  id: 'MOD_QUAL',
  title: 'Un modèle de Capacités de l’entreprise (Qualifications) ?',
  description: '',
  categories: [CONTENT_CATEGORY_MODEL],
  contents: [{
    type: CONTENT_TYPE_TEXT,
    value: 'Si vous ne possédez pas de Qualifications, veuillez prendre le modèle suivant :'
  },
  {
    type: CONTENT_TYPE_INTERNAL_LINK,
    value: DOCUMENT_PATH,
    label: 'Capacité d’entreprises.'
  }]
};
